export function calculateAnalysisTotals({ basePrice, litres, discountPerUnit, profitPerUnit, deliveryTotal, fastDeliveryTotal, vatRate }) {
  const adjustedUnit = Math.max(basePrice - discountPerUnit, 0);
  const baseTotal = adjustedUnit * litres;
  const profitTotal = profitPerUnit * litres;
  const totalExclVAT = baseTotal + deliveryTotal + fastDeliveryTotal + profitTotal;
  return { baseTotal, profitTotal, totalExclVAT, totalInclVAT: totalExclVAT * (1 + vatRate) };
}
